export default __webpack_public_path__ + "static/media/IMG_2470.218ed953.jpg";